module.exports = __webpack_public_path__ + "images/erp-nation-glad-top-2026-2027.1790221230673.jpg";